import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Icon, Dropdown, Popup, Flag } from 'semantic-ui-react';
import { Accounts } from 'actions';
import { colors } from 'utils/colors';
import { isQuoteMedia, isNB } from 'utils/helpers';

// eslint-disable-next-line react/prefer-stateless-function
class PortfolioAccountSelector extends Component {
  componentDidMount() {
    const { dispatch, accountData } = this.props;
    if (!accountData) {
      dispatch(Accounts.fetchAllData());
    }
  }

  getDropOptionsPort = () => {
    const { portfolios, value, partnerName } = this.props;

    const icons = {
      'WS All-In': 'lightning',
      'WS Adventurous': 'map signs',
      'WS Classic': 'leaf',
      'WS Cautious': 'cloud',
      'WS Playing-It-Safe': 'anchor',
    };

    return portfolios
      .filter((portf) => (isNB(partnerName) ? !portf.is_mp : true))
      .map((portf) => ({
        key: portf.id,
        value: portf.id,
        selected: portf.id === value,
        icon: portf.is_mp ? icons[portf.name] : 'folder open',
        text: portf.name,
      }));
  };

  getDropOptionsAcc = () => {
    const { accountData, value } = this.props;
    if (!accountData) return [];

    return accountData.map((acc) => ({
      key: acc.id,
      value: acc.id,
      selected: acc.id === value,
      text: (
        <span
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
          }}
        >
          <Icon name="book" />
          <span style={{ width: '75%' }}>
            {acc.user_institution}:<wbr />
            {acc.label}
          </span>
          <Flag name={acc.currency === 'USD' ? 'us' : 'ca'} />
        </span>
      ),
      content: (
        <Popup
          trigger={
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '0.78571429rem',
                paddingBottom: '0.78571429rem',
                paddingLeft: '1.14285714rem',
                paddingRight: '1.14285714rem',
              }}
            >
              <Icon name="book" style={{ marginRight: 6 }} />
              <span style={{ width: '75%' }}>
                {acc.user_institution}:<wbr />
                {acc.label}
              </span>
              <Flag name={acc.currency === 'USD' ? 'us' : 'ca'} />
            </span>
          }
          position="top center"
          wide
          content={
            acc.user_institution
              ? `${acc.user_institution}: ${acc.currency} $${acc.balance}`
              : `${acc.currency} $${acc.balance}`
          }
        />
      ),
    }));
  };

  getLabel = (partnerName, french, isPorts) =>
    isPorts
      ? isQuoteMedia(partnerName)
        ? 'Simulations'
        : french
        ? 'Portefeuilles'
        : 'Porfolios'
      : isQuoteMedia(partnerName)
      ? 'Portfolios'
      : french
      ? 'Comptes'
      : 'Accounts';

  render() {
    const {
      portfolios,
      accountData,
      value,
      text,
      onChange,
      isPorts,
      updateIsPorts,
      french,
      partnerName,
    } = this.props;

    const options = isPorts
      ? this.getDropOptionsPort(portfolios)
      : this.getDropOptionsAcc(accountData);

    const selectedAccount =
      accountData && accountData.find((acc) => acc.id === value);
    const accountText =
      text ||
      (selectedAccount ? (
        <span
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          <Icon name="book" />
          <span style={{ width: '75%' }}>
            {selectedAccount.user_institution}:<wbr />
            {selectedAccount.label}
          </span>
          <Flag name={selectedAccount.currency === 'USD' ? 'us' : 'ca'} />
        </span>
      ) : (
        ''
      ));

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            minWidth: '592px',
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            margin: '1rem 0',
          }}
        >
          <TargetSelect
            isActive={isPorts}
            onClick={() => {
              updateIsPorts(true);
            }}
            hoverColor={colors.blue}
            backgrounColor="rgb(242, 245, 255)"
          >
            <Icon
              name="folder open"
              style={{
                fontSize: '15px',
                verticalAlign: 'initial',
                color: 'black',
              }}
            />
            {this.getLabel(partnerName, french, true)}
          </TargetSelect>
          <TargetSelect
            isActive={!isPorts}
            onClick={() => {
              updateIsPorts(false);
            }}
            hoverColor={colors.red}
            backgrounColor="rgb(255, 241, 241)"
          >
            <Icon
              name="book"
              style={{
                fontSize: '15px',
                verticalAlign: 'initial',
                color: 'black',
              }}
            />
            {this.getLabel(partnerName, french, false)}
          </TargetSelect>
        </div>
        {options.length > 0 ? (
          <DropdownWrapper isPorts={isPorts}>
            <Dropdown
              placeholder={
                isPorts
                  ? french
                    ? 'Portefeuille'
                    : 'Portfolio'
                  : french
                  ? 'Compte'
                  : 'Account'
              }
              selection
              options={options}
              disabled={
                isPorts
                  ? portfolios.length === 0
                  : accountData && accountData.length === 0
              }
              value={value}
              text={isPorts ? text : accountText}
              selectOnBlur={false}
              onChange={onChange}
              style={{ width: '100%', margin: '0 auto' }}
              upward
              // Only use custom rendering for accounts

              renderLabel={isPorts ? undefined : undefined}
            />
          </DropdownWrapper>
        ) : (
          <div>
            {french
              ? `Vous n'avez actuellement aucun ${
                  isPorts ? 'portefeuille' : 'compte'
                } enregistré.`
              : `You currently have no saved ${
                  isPorts ? 'Portfolios' : 'Accounts'
                }.`}
          </div>
        )}
      </div>
    );
  }
}

PortfolioAccountSelector.propTypes = {
  dispatch: PropTypes.func.isRequired,
  portfolios: PropTypes.array,
  accountData: PropTypes.array,
  value: PropTypes.string,
  text: PropTypes.string,
  onChange: PropTypes.func,
  isPorts: PropTypes.bool,
  updateIsPorts: PropTypes.func,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
};

PortfolioAccountSelector.defaultProps = {
  portfolios: [],
  accountData: [],
  value: '',
  text: '',
  onChange: () => {},
  isPorts: true,
  updateIsPorts: () => {},
  french: false,
  partnerName: '',
};

export default connect((state) => ({
  portfolios: state.Portfolio.model.concat(state.Portfolio.user),
  accountData: state.Accounts.accountData,
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
}))(PortfolioAccountSelector);

const TargetSelect = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  border: 1px solid
    ${({ isActive, hoverColor }) => (isActive ? hoverColor : colors.lightGrey)};
  background-color: ${({ isActive, backgrounColor }) =>
    isActive ? backgrounColor : 'white'};
  border-radius: 10px;
  cursor: pointer;
  width: 49%;
  padding: 0.5rem;
  height: 38px;
  :hover {
    border: 1px solid ${({ hoverColor }) => hoverColor};
  }
`;

const DropdownWrapper = styled.div`
  width: 100%;
  margin: 0 auto;

  .ui.dropdown {
    max-width: 100% !important;
  }

  ${({ isPorts }) =>
    !isPorts &&
    `
    .ui.dropdown .menu > .item {
      padding: 0 !important;
    }
  `}
`;
